
import React from 'react';
import './education.css';

const Education = () => {
  return (
    <table className="table">
        <thead>
            <tr>
                <th>Degree</th>
                <th>Department</th>
                <th>Institute</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Diplome</td>
                <td>General</td>
                <td>Iteletique Bujumbura</td>
            </tr>
            <tr>
                <td>BIT</td>
                <td>Computer Scienc CS</td>
                <td>Universite des Grand Lacs UGL</td>
            </tr>
            <tr>
                <td>BIT</td>
                <td>BCs</td>
                <td>Cavendish University Uganda</td>
            </tr>
        </tbody>
    </table>
  )
}

export default Education